export default "__VITE_ASSET__BSHXCiwU__"